var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBallPilePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M3.8 15.197l.164.006c1.25.082 2.25 1.094 2.33 2.36l.006.166-.005.166c-.085 1.32-1.17 2.365-2.495 2.365-1.38 0-2.5-1.133-2.5-2.531 0-1.342 1.032-2.44 2.336-2.526l.164-.005zm4.79.685a8.13 8.13 0 003.102 3.948l-.042.03c-.39.253-.853.4-1.35.4-1.38 0-2.5-1.133-2.5-2.531 0-.729.304-1.385.79-1.847zM16.2 6.6a6.501 6.501 0 010 13 6.501 6.501 0 010-13zm.55 2.57h-1.1a.558.558 0 00-.55.563v2.25h-2.2a.557.557 0 00-.55.562v1.125c0 .31.248.563.55.563h2.2v2.25c0 .309.248.562.55.562h1.1c.302 0 .55-.253.55-.563v-2.25h2.2c.302 0 .55-.253.55-.562v-1.125a.558.558 0 00-.55-.563h-2.2v-2.25a.558.558 0 00-.55-.562zm-9.95.206l.164.005a2.478 2.478 0 011.675.811 8.068 8.068 0 00-.485 3.844c-.39.254-.855.402-1.354.402-1.38 0-2.5-1.133-2.5-2.531 0-1.342 1.032-2.44 2.336-2.526l.164-.005zM10.3 3.7a2.51 2.51 0 012.458 2.068 8.105 8.105 0 00-3.302 2.846A2.53 2.53 0 017.8 6.23c0-1.397 1.12-2.53 2.5-2.53z"
  }))));
}

export default SvgBallPilePlus;